import React from 'react';
import firebase from '../../helper/firebase';
import _ from 'lodash';

import { Link } from 'react-router-dom';

import Head from '../../components/Head';
import LoggedOutCard from '../../components/LoggedOutCard';
import UnauthorizedText from '../../components/UnauthorizedText';

import { Title } from '../../helper/consts';

import { Button, CircularProgress, Paper, Tabs, Tab } from 'material-ui';

import Table, {
	TableBody,
	TableCell,
	TableHead,
	TableRow
} from 'material-ui/Table';

import Fade from 'material-ui/transitions/Fade';

const style = {
	loading: {
		alignSelf: 'center',
		width: '75px',
		height: '75px',
		marginTop: 'calc(50vh - 37.5px - 64px)'
	},
	statusMessage: {
		textTransform: 'capitalize'
	},
	offerStatus: {
		textTransform: 'capitalize',
		textDecoration: 'underline'
	},
	jobStatus: {
		textTransform: 'capitalize'
	}
};

export default class Commissions extends React.Component {
	constructor() {
		super();

		this.state = {
			loggedIn: false,
			authLoading: true,
			loading: true,
			archiveLoading: true,
			jobs: {},
			archives: false
		};
	}

	componentDidMount() {
		// this.props.actions.getMyListener([{uid:'',stateName:'commissions',dbName:'myCommissions',dispatchName:'JobsState/GET_COMMISSIONS',getJobs:true},])
		// this.props.actions.getReferences([{uid:'',stateName:'myOffers',dbName:'myOffers',dispatchName:'JobsState/GET_MYOFFERS',getJobs:false},])
		firebase.auth().onAuthStateChanged(user => {
			if (user) {
				this.getInfo(user.uid);
				this.setState({
					uid: user.uid,
					user: user.providerData[0],
					loggedIn: true,
					authLoading: false,
					loading: true,
					jobs: {}
				});
			} else {
				firebase
					.database()
					.ref(`myOffers/${this.state.uid}`)
					.off();
				firebase
					.database()
					.ref(`myCommissions/${this.state.uid}`)
					.off();
				this.setState({
					loggedIn: false,
					authLoading: false,
					loading: true,
					user: {},
					uid: '',
					jobs: {}
				});
			}
		});
	}

	componentWillUnmount() {
		this.props.uid &&
			this.props.loggedIn &&
			firebase
				.database()
				.ref(`myCommissions/${this.props.uid}`)
				.off();
		// this.props.uid && this.props.loggedIn && firebase.database().ref(`myOffers/${this.props.uid}`).off()
		firebase
			.database()
			.ref(`myOffers/${this.state.uid}`)
			.off();
		firebase
			.database()
			.ref(`myCommissions/${this.state.uid}`)
			.off();
	}

	getInfo = uid => {
		//get myCommissions {archived, jid, oid, status, timestamp}
		//forEach
		// get job {about, commission, company, companyURI, created, details, geopoint, glassdoorId, jid, location, privateCompanyStats, privateOfferStats, publicJob, status, title, uid, updated}
		// get offer {jid, oid, users}
		// get myOffer {jid, oid, shareCount, timestamp}
		const ref = firebase.database().ref();
		let { jobs } = this.state;
		let promises = [];
		ref.child(`myCommissions/${uid}`).on('value', myCommissionsSnap => {
			if (!myCommissionsSnap.val()) {
				console.log('no commissions');
				this.setState({ loading: false, jobs: {} });
			} else {
				let counter = myCommissionsSnap.numChildren();
				myCommissionsSnap.forEach(myCommission => {
					const { jid, oid } = myCommission.val();
					jobs[jid] = {};
					jobs[jid].commission = myCommission.val();
					const jobPromise = firebase
						.firestore()
						.collection('jobs')
						.doc(jid)
						.get()
						.then(jobSnap => {
							if (jobSnap.data() !== null) {
								jobs[jid].job = jobSnap.data();
							}
						});
					promises.push(jobPromise);
					const offerPromise = firebase
						.firestore()
						.collection('offers')
						.doc(oid)
						.get()
						.then(offerSnap => {
							jobs[jid].offer = offerSnap.data();
						});
					promises.push(offerPromise);
					const myOfferPromise = ref
						.child(`myOffers/${uid}/${jid}/shareCount`)
						.once('value')
						.then(myOfferSnap => {
							jobs[jid].shareCount = myOfferSnap.val();
						});
					promises.push(myOfferPromise);
					counter--;
					if (counter === 0) {
						Promise.all(promises)
							.then(() => {
								this.setState({ jobs, loading: false });
							})
							.catch(err => {
								this.props.actions.setSnack(true, 'Error: Please try again');
							});
					}
				});
			}
		});
	};

	renderJobs = () => {
		let html = [];
		let { jobs, archives } = this.state;
		if (_.isEmpty(jobs)) {
			return html;
		} else {
			Object.keys(jobs)
				.map(jid => jobs[jid])
				.filter(job => !!job.commission.archived === !!archives)
				.forEach(job => {
					if (job.offer !== undefined && job.job !== undefined) {
						let row = (
							<TableRow key={job.job.jid}>
								<TableCell padding="dense">{job.job.company}</TableCell>
								<TableCell padding="dense" numeric>
									<Link style={style.offerStatus} to={`Offer/${job.offer.oid}`}>
										{job.job.status}
									</Link>
								</TableCell>
								<TableCell padding="none" numeric>
									{job.shareCount || 0}
								</TableCell>
								<TableCell padding="dense" numeric>
									${job.commission.commission.toFixed(2)}
								</TableCell>
								{job.commission && job.commission.status !== undefined ? (
									<TableCell padding="dense" style={style.jobStatus} numeric>
										{job.commission.status}
									</TableCell>
								) : (
									<TableCell padding="dense" numeric>
										N/A
									</TableCell>
								)}

								{job.job &&
									job.job.status !== 'hired' && (
										<TableCell>
											<Button dense disabled>
												Pending
											</Button>
										</TableCell>
									)}
								{job.job &&
									job.job.status === 'hired' &&
									job.commission &&
									(job.commission.status === 'paid' ||
										job.commission.status === 'declined') && (
										<TableCell padding="dense" numeric>
											<Button
												dense={true}
												onClick={() => {
													this.archiveCommission(job.job.jid, !archives);
												}}
											>
												{!!archives ? 'Unarchive' : 'Archive'}
											</Button>
										</TableCell>
									)}
								{job.job &&
									job.job.status === 'hired' &&
									job.commission &&
									job.commission.status !== 'paid' &&
									job.commission.status !== 'declined' && (
										<TableCell padding="dense" numeric>
											<Link
												className="cardActionsBtn"
												to={`Commission/${job.job.jid}`}
											>
												<Button dense={true} color="accent">
													View
												</Button>
											</Link>
										</TableCell>
									)}
							</TableRow>
						);
						html.push(row);
					}
				});
		}
		return html;
	};

	archiveCommission = (jid, status) => {
		const { uid } = this.state;
		firebase
			.database()
			.ref(`myCommissions/${uid}/${jid}/`)
			.update({ archived: status })
			.then(() => {
				this.props.actions.setSnack(
					true,
					`Success: ${!!status ? 'archived' : 'unarchived'}.`
				);
			})
			.catch(err => {
				this.props.actions.setSnack(true, 'Error: Job not archived');
			});
	};

	handleArchive = (jid, status) => {
		firebase
			.database()
			.ref(`myCommissions/${this.props.uid}/${jid}`)
			.update({ archived: status })
			.then(() => {
				this.props.actions.setSnack(
					true,
					`Success: ${!!status ? 'archived' : 'unarchived'}.`
				);
			})
			.catch(err => {
				this.props.actions.setSnack(true, 'Error: Please try again.');
			});
	};

	handleTabChange = (e, value) => this.setState({ tab: value });

	renderTabs = () => {
		let html = [];
		let tabs = (
			<Tabs
				value={this.state.tab || 0}
				onChange={this.handleTabChange}
				indicatorColor="primary"
				textColor="primary"
				centered
				key="jobs_tabs"
			>
				<Tab
					onClick={() => {
						this.setState({ archives: false });
					}}
					label="Active"
				/>
				<Tab
					onClick={() => {
						this.setState({ archives: true });
					}}
					label="Archived"
				/>
			</Tabs>
		);
		html.push(tabs);
		return html;
	};

	render() {
		return (
			<React.Fragment>
				<Head title={`Commissions | ${Title}`} />
				<div id={this.state.loggedIn ? 'loggedInBody' : null} className="body">
					{((this.state.loading &&
						this.state.authLoading &&
						!this.state.loggedIn) ||
						(this.state.loading &&
							!this.state.authLoading &&
							this.state.loggedIn)) && (
						<CircularProgress style={style.loading} size={75} />
					)}

					{!this.state.loading &&
						!this.props.authLoading &&
						this.props.loggedIn &&
						!this.props.adminLoading &&
						!this.props.admin &&
						this.renderTabs()}

					{!this.state.loading &&
						!this.props.authLoading &&
						this.props.loggedIn &&
						!this.props.adminLoading &&
						!this.props.admin && (
							<Fade key="jobs" in={true}>
								<Paper className="card">
									<Table>
										<TableHead>
											<TableRow>
												<TableCell padding="dense">Company</TableCell>
												<TableCell padding="dense" numeric>
													Status
												</TableCell>
												<TableCell padding="none" numeric>
													Shares
												</TableCell>
												<TableCell padding="dense" numeric>
													Potential Commission
												</TableCell>
												<TableCell padding="dense" numeric>
													Commission Status
												</TableCell>
												<TableCell padding="dense" numeric>
													Action
												</TableCell>
											</TableRow>
										</TableHead>
										<TableBody>{this.renderJobs()}</TableBody>
									</Table>
								</Paper>
							</Fade>
						)}

					{!this.props.authLoading && !this.props.loggedIn && <LoggedOutCard />}

					{!this.state.loading &&
						!this.props.authLoading &&
						this.props.loggedIn &&
						!this.props.adminLoading &&
						this.props.admin && (
							<div className="unauthorizedTextContainer">
								<UnauthorizedText
									text="Unauthorized"
									subText="Access is limited"
								/>
							</div>
						)}
				</div>
			</React.Fragment>
		);
	}
}



// WEBPACK FOOTER //
// ./src/pages/Commissions/Commissions.js